import LegalDocumentPage from "../../utils/LegalDocumentPage";
import privacyPolicyContent from "../../content/privacyPolicyContent.json";

const PrivacyPolicy = () => <LegalDocumentPage content={privacyPolicyContent} />;

export default PrivacyPolicy;
